import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-video",
  "use": "icon-video-usage",
  "viewBox": "0 0 1433 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1433 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-video\"><defs><style type=\"text/css\"></style></defs><path d=\"M329.866827 432.246351a102.379524 102.379524 0 1 1 0-204.554289 102.379524 102.379524 0 0 1 0 204.554289m1061.880424-254.925015a57.230154 57.230154 0 0 0-58.561088 3.071385l-162.783444 110.365127V113.846031c0-62.861028-50.882623-113.743651-113.641271-113.846031h-942.915417C50.882623 0 0 50.985003 0 113.743651V910.153969c0 62.861028 50.985003 113.846031 113.743651 113.846031h943.017797a113.846031 113.846031 0 0 0 113.641271-113.846031V834.393121l0.716657-45.04699 161.759648 110.877024a56.923015 56.923015 0 0 0 89.070186-47.094581v-625.538892a57.127774 57.127774 0 0 0-30.201959-50.268346\" p-id=\"6429\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/video.svg
// module id = 1066
// module chunks = 36